import {
  FormCEPInput,
  FormInput,
  FormSelect,
  FormTextarea,
} from '@/components/ui/FormFields'
import { SingleImageUpload } from '@/components/ui/SingleImageUpload/SingleImageUpload'
import { BRAZILIAN_STATES } from '@/constants/brazilianStates'
import { useStaysMultyUnitPropertyTypes } from '@/hooks/stays/useStaysMultyPropertyTypes'
import { MultiLanguageString } from '@/lib/api/stays/types/shared-types'
import {
  StaysPropertyFormInput,
  StaysPropertyFormOutput,
} from '@/schemas/stays/staysPropertySchema'
import { getLocalizedText } from '@/utils/getLocalizedText'
import { GridItem, SimpleGrid, VStack } from '@chakra-ui/react'
import { Control } from 'react-hook-form'

interface StaysPropertyStepProps {
  control: Control<StaysPropertyFormInput, any, StaysPropertyFormOutput>
}

export const StaysPropertyStep = ({ control }: StaysPropertyStepProps) => {
  const { stMultyUnitPropertyTypes } = useStaysMultyUnitPropertyTypes()
  return (
    <VStack spacing={6} align="stretch" w={'full'}>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
        <FormSelect
          name="_idtype"
          label="Tipo de Endereço"
          control={control}
          options={stMultyUnitPropertyTypes.map(({ stays_id, _mstitle }) => ({
            value: stays_id,
            label: getLocalizedText(
              (_mstitle as MultiLanguageString) ?? undefined
            ),
          }))}
          isRequired
        />

        <FormInput
          name="internalname"
          label="Referência Interna"
          control={control}
          isRequired
          placeholder="SOU PERDIZES"
          textTransform="uppercase"
        />

        <FormInput
          name="_mstitle"
          label="Nome da Propriedade"
          control={control}
          isRequired
          placeholder="Condomino do sol"
        />
      </SimpleGrid>

      <SimpleGrid
        columns={{ base: 1, md: 3 }}
        gridTemplateColumns={'2fr 1fr 1.5fr'}
        spacing={4}
      >
        <FormInput
          name="address.street"
          label="Logradouro"
          control={control}
          isRequired
          placeholder="Rua das flores"
        />

        <FormInput
          name="address.streetNumber"
          label="Número"
          control={control}
          isRequired
          placeholder="15908"
        />

        <FormInput
          name="address.region"
          label="Bairro"
          control={control}
          isRequired
          placeholder="Perdizes"
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
        <FormInput
          name="address.city"
          label="Cidade"
          control={control}
          isRequired
          placeholder="São Paulo"
        />

        <FormSelect
          name="address.stateCode"
          label="Estado"
          control={control}
          options={BRAZILIAN_STATES.map((s) => ({ ...s }))}
          isRequired
        />

        <FormCEPInput
          name="address.zip"
          label="CEP"
          control={control}
          isRequired
        />
      </SimpleGrid>
      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} paddingBottom={4}>
        <GridItem colSpan={2}>
          <FormTextarea
            name="_msdesc"
            label="Descrição (Opcional)"
            control={control}
            placeholder="Descreva as características especiais da propriedade..."
            rows={4}
            className="gri"
          />
        </GridItem>
        <GridItem colStart={{ base: 1, md: 3 }}>
          <SingleImageUpload<StaysPropertyFormInput>
            control={control}
            name="images"
          />
        </GridItem>
      </SimpleGrid>
    </VStack>
  )
}
